// extracted by mini-css-extract-plugin
module.exports = {"nav":"Nav_nav__3Bj6t","sticky":"Nav_sticky__26r0C","links":"Nav_links__16cF2","restofLinks":"Nav_restofLinks__YXUx_"};